// Module
var code = `<button class="button"> </button>`;
// Exports
export default code;